<template>
	<router-view />
</template>

<script>
	export default {
		name: 'SignupTopRoute',
	}
</script>
<style lang="scss"></style>
